import React from 'react';

export const SmootherContext = React.createContext(null);
